function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './CheckboxField.css';
import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
const Checkbox = props => {
  const {
    required = false,
    value: contextValue = false,
    label = 'label',
    name = 'name',
    updateContext,
    rtl = false,
    patternInvalidMessage = 'validateError',
    validate = false
  } = props;
  const [inValid, setInValid] = useState(false);
  const onChangeEvent = (value, validateFlag) => {
    required && setInValid(!validateFlag);
    updateContext({
      [name]: _objectSpread(_objectSpread({}, props), {}, {
        valid: required && validateFlag,
        value
      })
    });
  };
  useEffect(() => {
    if (validate) required && setInValid(!inValid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validate]);
  useEffect(() => {
    if (required) updateContext({
      [name]: _objectSpread(_objectSpread({}, props), {}, {
        required,
        valid: contextValue
      })
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [required]);
  return /*#__PURE__*/React.createElement("fieldset", {
    className: `${rtl ? rtlStyles : ltrStyles} ${styles}`
  }, /*#__PURE__*/React.createElement("span", {
    className: "form-input__wrapper"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    className: `form-input__checkbox ${inValid ? ' invalid-field' : ''}c`,
    onChange: event => {
      onChangeEvent(event.target.checked, event.currentTarget.validity.valid);
    },
    onKeyPress: event => {
      if (event.key === 'Enter' || event.key === 'NumpadEnter') {
        event.preventDefault();
        event.target.checked = !event.target.checked;
        onChangeEvent(event.target.checked, event.currentTarget.validity.valid);
      }
    },
    checked: !!contextValue,
    required: required,
    name: name,
    id: name
  }), label && /*#__PURE__*/React.createElement("label", {
    className: `body-small wiz__label--checkbox  `,
    htmlFor: name
  }, ReactHtmlParser(label))), inValid && /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("p", {
    className: "text-input__error"
  }, patternInvalidMessage)));
};
const styles = "s1c2h7z2";
const ltrStyles = "lbahdkt";
const rtlStyles = "rm63ioa";
export default Checkbox;